var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Form, Input, FormGroup, FormFeedback, InputGroup, InputGroupText, FormText } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
export const validateForm = (e, submitFn) => {
    const { target } = e;
    const isFormValid = target.checkValidity();
    if (isFormValid) {
        submitFn(e);
    }
};
const RVForm = (_a) => {
    var { className = 'reactstrap-form', children, noValidate = false, onSubmit } = _a, rest = __rest(_a, ["className", "children", "noValidate", "onSubmit"]);
    return (_jsx(Form, Object.assign({ className: className, noValidate: noValidate, onSubmit: (e) => {
            if (noValidate && onSubmit) {
                e.preventDefault();
                validateForm(e, onSubmit);
            }
            else {
                if (onSubmit) {
                    onSubmit(e);
                }
            }
        } }, rest, { children: children })));
};
const RVInputGroup = (_a) => {
    var { className = 'reactstrap-form-inputgroup', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx(InputGroup, Object.assign({ className: className }, rest, { children: children })));
};
const RVInputGroupText = (_a) => {
    var { className = 'reactstrap-form-inputgroup-text', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx(InputGroupText, Object.assign({ className: className }, rest, { children: children })));
};
const RVFormGroup = (_a) => {
    var { className = 'reactstrap-form-group', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx(FormGroup, Object.assign({ className: className }, rest, { children: children })));
};
const RVFormText = (_a) => {
    var { className = 'reactstrap-form-text', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx(FormText, Object.assign({ className: className }, rest, { children: children })));
};
const RVFormFeedback = (_a) => {
    var { className = 'reactstrap-form-feedback', children = 'A mező kitöltése kötelező!' } = _a, rest = __rest(_a, ["className", "children"]);
    return (_jsx(FormFeedback, Object.assign({ className: className }, rest, { children: children })));
};
const RVInput = (_a) => {
    var { className = 'reactstrap-form-input', onChange = () => { } } = _a, rest = __rest(_a, ["className", "onChange"]);
    const [isValid, setIsValid] = useState(true);
    const validate = (e) => {
        if (e.target.type === 'checkbox' && e.target.required) {
            if (e.target.checked === false) {
                setIsValid(false);
            }
            else {
                setIsValid(true);
            }
        }
        else {
            if (e.target.value === '' && e.target.required) {
                setIsValid(false);
            }
            else {
                setIsValid(true);
            }
        }
    };
    return (_jsx(Input, Object.assign({ onChange: (e) => {
            onChange(e);
            validate(e);
        }, onInvalid: (e) => validate(e), invalid: !isValid, className: className }, rest)));
};
export { RVForm, RVFormGroup, RVInput, RVInputGroup, RVInputGroupText, RVFormFeedback, RVFormText };
//# sourceMappingURL=RVForm.js.map